import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import clsx from 'clsx'

const useStyles = makeStyles<Theme>((theme) => ({
  iconButton: {
    cursor: 'pointer',
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: theme.components.button.primary.background,
    color: theme.components.button.primary.color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  icon: {
    color: theme.components.button.primary.color,
    fontSize: 12,
  },
}))

interface RemoveButtonProps {
  index: number
  onRemove: (index: number) => void
  className?: string
}

const RemoveButton: React.FC<RemoveButtonProps> = ({ index, onRemove, className }) => {
  const classes = useStyles()

  const handleClick = () => {
    onRemove(index)
  }

  return (
    <div
      className={clsx(classes.iconButton, className)}
      onClick={handleClick}
      title="Remove access rule"
    >
      <FontAwesomeIcon solid className={classes.icon}>
        minus
      </FontAwesomeIcon>
    </div>
  )
}

export default RemoveButton
